import {BaseApi} from "./BaseApi";
import {BloodPressure} from "./models";
import {Client} from "./models";
import {MeasurementTypeConfiguration} from "./models";
import {Measurement} from "./models";
import {Medicine} from "./models";
import {Prescription} from "./models";
import {Therapist} from "./models";
import {User} from "./models";

export interface Typeform_Form {
    id?: string;
    type?: string;
    title?: string;
}

export interface Typeform_Form_Response {
    landing_id?: string;
    token?: string;
    response_id?: string;
    landed_at?: string;
    submitted_at?: string;
    metadata?: Typeform_Form_Response_Metadata;
    calculated?: Typeform_Form_Response_Calculated;
    answers?: Typeform_Form_Response_Answer[];
    variables?: Typeform_Form_Response_Variable[];
    outcome?: Typeform_Form_Response_Outcome;
    description?: string;
}

export interface Typeform_Form_Response_Answer {
    field?: Typeform_Form_Response_Answer_Field;
    type?: string;
    text?: string;
    boolean?: boolean;
    email?: string;
}

export interface Typeform_Form_Response_Answer_Field {
    id?: string;
    ref?: string;
    type?: string;
}

export interface Typeform_Form_Response_Calculated {
    score?: number;
}

export interface Typeform_Form_Response_Metadata {
    user_agent?: string;
    platform?: string;
    referer?: string;
    network_id?: string;
    browser?: string;
}

export interface Typeform_Form_Response_Outcome {
    id?: string;
    ref?: string;
    title?: string;
}

export interface Typeform_Form_Response_Variable {
    key?: string;
    type?: string;
    number?: number;
    outcome_id?: string;
}

export interface Typeform_GetFormUrl_Response {
    value?: string;
}


export class BloodPressuresGet extends BaseApi<BloodPressure> {

    public topic = 'Resources.BloodPressures';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/blood_pressures`;
    }

    protected convertToResource(data: any): BloodPressure {
        return new BloodPressure(data);
    }

    public where(name: string, value: any): BloodPressuresGet {
        this.filter().where(name, value);
        return this;
    }

    public whereEquals(name: string, value: any): BloodPressuresGet {
        this.filter().whereEquals(name, value);
        return this;
    }

    public whereIn(name: string, value: any[]): BloodPressuresGet {
        this.filter().whereIn(name, value);
        return this;
    }

    public whereInArray(name: string, value: any[]): BloodPressuresGet {
        this.filter().whereInArray(name, value);
        return this;
    }

    public whereNot(name: string, value: any): BloodPressuresGet {
        this.filter().whereNot(name, value);
        return this;
    }

    public whereNotIn(name: string, value: any[]): BloodPressuresGet {
        this.filter().whereNotIn(name, value);
        return this;
    }

    public whereGreaterThan(name: string, value: any): BloodPressuresGet {
        this.filter().whereGreaterThan(name, value);
        return this;
    }

    public whereGreaterThanOrEqual(name: string, value: any): BloodPressuresGet {
        this.filter().whereGreaterThanOrEqual(name, value);
        return this;
    }

    public whereLessThan(name: string, value: any): BloodPressuresGet {
        this.filter().whereLessThan(name, value);
        return this;
    }

    public whereLessThanOrEqual(name: string, value: any): BloodPressuresGet {
        this.filter().whereLessThanOrEqual(name, value);
        return this;
    }

    public search(name: string, value: any): BloodPressuresGet {
        this.filter().search(name, value);
        return this;
    }

    public include(name: string): BloodPressuresGet {
        this.getInclude().include(name);
        return this;
    }

    public orderBy(name: string, direction: string): BloodPressuresGet {
        this.ordering().orderBy(name, direction);
        return this;
    }

    public orderAsc(name: string): BloodPressuresGet {
        this.ordering().orderAsc(name);
        return this;
    }

    public orderDesc(name: string): BloodPressuresGet {
        this.ordering().orderDesc(name);
        return this;
    }

    public limit(value: number): BloodPressuresGet {
        this.limitValue = value;
        return this;
    }

    public offset(value: number): BloodPressuresGet {
        this.offsetValue = value;
        return this;
    }

    public count(next?: (value: number) => void) {
        return this.executeCount(next);
    }

    public find(next?: (value: BloodPressure[]) => void) {
        return super.executeFind(next);
    }
}

export class BloodPressuresGetById extends BaseApi<BloodPressure> {

    public topic = 'Resources.BloodPressures';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/blood_pressures/${id}`;
    }

    protected convertToResource(data: any): BloodPressure {
        return new BloodPressure(data);
    }

    public include(name: string): BloodPressuresGetById {
        this.getInclude().include(name);
        return this;
    }

    public find(next?: (value: BloodPressure[]) => void) {
        return super.executeFind(next);
    }
}

export class BloodPressuresPost extends BaseApi<BloodPressure> {

    public topic = 'Resources.BloodPressures';
    protected method = 'post';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/blood_pressures`;
    }

    protected convertToResource(data: any): BloodPressure {
        return new BloodPressure(data);
    }

    public save(data: BloodPressure, next?: (value: BloodPressure) => void) {
        return super.executeSave(data, next);
    }
}

export class BloodPressuresPutById extends BaseApi<BloodPressure> {

    public topic = 'Resources.BloodPressures';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/blood_pressures/${id}`;
    }

    protected convertToResource(data: any): BloodPressure {
        return new BloodPressure(data);
    }

    public save(data: BloodPressure, next?: (value: BloodPressure) => void) {
        return super.executeSave(data, next);
    }
}

export class BloodPressuresPut extends BaseApi<BloodPressure> {

    public topic = 'Resources.BloodPressures';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/blood_pressures`;
    }

    protected convertToResource(data: any): BloodPressure {
        return new BloodPressure(data);
    }

    public save(data: BloodPressure, next?: (value: BloodPressure) => void) {
        return super.executeSave(data, next);
    }
}

export class BloodPressuresPatchById extends BaseApi<BloodPressure> {

    public topic = 'Resources.BloodPressures';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/blood_pressures/${id}`;
    }

    protected convertToResource(data: any): BloodPressure {
        return new BloodPressure(data);
    }

    public save(data: BloodPressure, next?: (value: BloodPressure) => void) {
        return super.executeSave(data, next);
    }
}

export class BloodPressuresPatch extends BaseApi<BloodPressure> {

    public topic = 'Resources.BloodPressures';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/blood_pressures`;
    }

    protected convertToResource(data: any): BloodPressure {
        return new BloodPressure(data);
    }

    public save(data: BloodPressure, next?: (value: BloodPressure) => void) {
        return super.executeSave(data, next);
    }
}

export class BloodPressuresDeleteById extends BaseApi<BloodPressure> {

    public topic = 'Resources.BloodPressures';
    protected method = 'delete';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/blood_pressures/${id}`;
    }

    protected convertToResource(data: any): BloodPressure {
        return new BloodPressure(data);
    }

    public delete(next?: (value: BloodPressure) => void) {
        return super.executeDelete(next);
    }
}

class BloodPressures {

    public get(): BloodPressuresGet {
        return new BloodPressuresGet();
    }

    public getById(id: number): BloodPressuresGetById {
        return new BloodPressuresGetById(id);
    }

    public post(): BloodPressuresPost {
        return new BloodPressuresPost();
    }

    public putById(id: number): BloodPressuresPutById {
        return new BloodPressuresPutById(id);
    }

    public put(): BloodPressuresPut {
        return new BloodPressuresPut();
    }

    public patchById(id: number): BloodPressuresPatchById {
        return new BloodPressuresPatchById(id);
    }

    public patch(): BloodPressuresPatch {
        return new BloodPressuresPatch();
    }

    public deleteById(id: number): BloodPressuresDeleteById {
        return new BloodPressuresDeleteById(id);
    }

}


export class ClientsGet extends BaseApi<Client> {

    public topic = 'Resources.Clients';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/clients`;
    }

    protected convertToResource(data: any): Client {
        return new Client(data);
    }

    public where(name: string, value: any): ClientsGet {
        this.filter().where(name, value);
        return this;
    }

    public whereEquals(name: string, value: any): ClientsGet {
        this.filter().whereEquals(name, value);
        return this;
    }

    public whereIn(name: string, value: any[]): ClientsGet {
        this.filter().whereIn(name, value);
        return this;
    }

    public whereInArray(name: string, value: any[]): ClientsGet {
        this.filter().whereInArray(name, value);
        return this;
    }

    public whereNot(name: string, value: any): ClientsGet {
        this.filter().whereNot(name, value);
        return this;
    }

    public whereNotIn(name: string, value: any[]): ClientsGet {
        this.filter().whereNotIn(name, value);
        return this;
    }

    public whereGreaterThan(name: string, value: any): ClientsGet {
        this.filter().whereGreaterThan(name, value);
        return this;
    }

    public whereGreaterThanOrEqual(name: string, value: any): ClientsGet {
        this.filter().whereGreaterThanOrEqual(name, value);
        return this;
    }

    public whereLessThan(name: string, value: any): ClientsGet {
        this.filter().whereLessThan(name, value);
        return this;
    }

    public whereLessThanOrEqual(name: string, value: any): ClientsGet {
        this.filter().whereLessThanOrEqual(name, value);
        return this;
    }

    public search(name: string, value: any): ClientsGet {
        this.filter().search(name, value);
        return this;
    }

    public include(name: string): ClientsGet {
        this.getInclude().include(name);
        return this;
    }

    public orderBy(name: string, direction: string): ClientsGet {
        this.ordering().orderBy(name, direction);
        return this;
    }

    public orderAsc(name: string): ClientsGet {
        this.ordering().orderAsc(name);
        return this;
    }

    public orderDesc(name: string): ClientsGet {
        this.ordering().orderDesc(name);
        return this;
    }

    public limit(value: number): ClientsGet {
        this.limitValue = value;
        return this;
    }

    public offset(value: number): ClientsGet {
        this.offsetValue = value;
        return this;
    }

    public count(next?: (value: number) => void) {
        return this.executeCount(next);
    }

    public find(next?: (value: Client[]) => void) {
        return super.executeFind(next);
    }
}

export class ClientsGetById extends BaseApi<Client> {

    public topic = 'Resources.Clients';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/clients/${id}`;
    }

    protected convertToResource(data: any): Client {
        return new Client(data);
    }

    public include(name: string): ClientsGetById {
        this.getInclude().include(name);
        return this;
    }

    public find(next?: (value: Client[]) => void) {
        return super.executeFind(next);
    }
}

export class ClientsPost extends BaseApi<Client> {

    public topic = 'Resources.Clients';
    protected method = 'post';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/clients`;
    }

    protected convertToResource(data: any): Client {
        return new Client(data);
    }

    public save(data: Client, next?: (value: Client) => void) {
        return super.executeSave(data, next);
    }
}

export class ClientsPutById extends BaseApi<Client> {

    public topic = 'Resources.Clients';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/clients/${id}`;
    }

    protected convertToResource(data: any): Client {
        return new Client(data);
    }

    public save(data: Client, next?: (value: Client) => void) {
        return super.executeSave(data, next);
    }
}

export class ClientsPut extends BaseApi<Client> {

    public topic = 'Resources.Clients';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/clients`;
    }

    protected convertToResource(data: any): Client {
        return new Client(data);
    }

    public save(data: Client, next?: (value: Client) => void) {
        return super.executeSave(data, next);
    }
}

export class ClientsPatchById extends BaseApi<Client> {

    public topic = 'Resources.Clients';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/clients/${id}`;
    }

    protected convertToResource(data: any): Client {
        return new Client(data);
    }

    public save(data: Client, next?: (value: Client) => void) {
        return super.executeSave(data, next);
    }
}

export class ClientsPatch extends BaseApi<Client> {

    public topic = 'Resources.Clients';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/clients`;
    }

    protected convertToResource(data: any): Client {
        return new Client(data);
    }

    public save(data: Client, next?: (value: Client) => void) {
        return super.executeSave(data, next);
    }
}

export class ClientsDeleteById extends BaseApi<Client> {

    public topic = 'Resources.Clients';
    protected method = 'delete';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/clients/${id}`;
    }

    protected convertToResource(data: any): Client {
        return new Client(data);
    }

    public delete(next?: (value: Client) => void) {
        return super.executeDelete(next);
    }
}

class Clients {

    public get(): ClientsGet {
        return new ClientsGet();
    }

    public getById(id: number): ClientsGetById {
        return new ClientsGetById(id);
    }

    public post(): ClientsPost {
        return new ClientsPost();
    }

    public putById(id: number): ClientsPutById {
        return new ClientsPutById(id);
    }

    public put(): ClientsPut {
        return new ClientsPut();
    }

    public patchById(id: number): ClientsPatchById {
        return new ClientsPatchById(id);
    }

    public patch(): ClientsPatch {
        return new ClientsPatch();
    }

    public deleteById(id: number): ClientsDeleteById {
        return new ClientsDeleteById(id);
    }

}


export class IntegrationsTypeformGetFormUrlGetByFormId extends BaseApi<Typeform_GetFormUrl_Response> {

    public topic = 'Resources.Typeform_GetFormUrl_Responses';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(formId: string) {
        super();
        this.uri = `/integrations/typeform/forms/${formId}/url`;
    }

    protected convertToResource(data: any): Typeform_GetFormUrl_Response {
        return data;
    }

    public clientId(value: number): IntegrationsTypeformGetFormUrlGetByFormId {
        this.addQueryParameter('clientId', value);
        return this;
    }

    public find(next?: (value: Typeform_GetFormUrl_Response[]) => void) {
        return super.executeFind(next);
    }
}

export class IntegrationsTypeformRedirectToFormGetByFormId extends BaseApi<any> {

    public topic = 'UnknownResource';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(formId: string) {
        super();
        this.uri = `/integrations/typeform/forms/${formId}/redirect`;
    }

    protected convertToResource(data: any): any {
        return data;
    }

    public find(next?: (value: any[]) => void) {
        return super.executeFind(next);
    }
}

export class IntegrationsTypeformGetFormsGet extends BaseApi<Typeform_Form> {

    public topic = 'Resources.Typeform_Forms';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/integrations/typeform/forms`;
    }

    protected convertToResource(data: any): Typeform_Form {
        return data;
    }

    public find(next?: (value: Typeform_Form[]) => void) {
        return super.executeFind(next);
    }
}

export class IntegrationsTypeformGetFormResponsesGetByFormId extends BaseApi<Typeform_Form_Response> {

    public topic = 'Resources.Typeform_Form_Responses';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(formId: string) {
        super();
        this.uri = `/integrations/typeform/forms/${formId}/responses`;
    }

    protected convertToResource(data: any): Typeform_Form_Response {
        return data;
    }

    public find(next?: (value: Typeform_Form_Response[]) => void) {
        return super.executeFind(next);
    }
}

export class IntegrationsTypeformRedirectToFormResponseGetByFormIdByResponseId extends BaseApi<any> {

    public topic = 'UnknownResource';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(formId: string, responseId: string) {
        super();
        this.uri = `/integrations/typeform/forms/${formId}/responses/${responseId}/redirect`;
    }

    protected convertToResource(data: any): any {
        return data;
    }

    public find(next?: (value: any[]) => void) {
        return super.executeFind(next);
    }
}

class IntegrationsTypeform {

    public getFormUrlGetByFormId(formId: string): IntegrationsTypeformGetFormUrlGetByFormId {
        return new IntegrationsTypeformGetFormUrlGetByFormId(formId);
    }

    public redirectToFormGetByFormId(formId: string): IntegrationsTypeformRedirectToFormGetByFormId {
        return new IntegrationsTypeformRedirectToFormGetByFormId(formId);
    }

    public getFormsGet(): IntegrationsTypeformGetFormsGet {
        return new IntegrationsTypeformGetFormsGet();
    }

    public getFormResponsesGetByFormId(formId: string): IntegrationsTypeformGetFormResponsesGetByFormId {
        return new IntegrationsTypeformGetFormResponsesGetByFormId(formId);
    }

    public redirectToFormResponseGetByFormIdByResponseId(formId: string, responseId: string): IntegrationsTypeformRedirectToFormResponseGetByFormIdByResponseId {
        return new IntegrationsTypeformRedirectToFormResponseGetByFormIdByResponseId(formId, responseId);
    }

}


export class MeasurementTypeConfigurationsGet extends BaseApi<MeasurementTypeConfiguration> {

    public topic = 'Resources.MeasurementTypeConfigurations';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/measurement_type_configurations`;
    }

    protected convertToResource(data: any): MeasurementTypeConfiguration {
        return new MeasurementTypeConfiguration(data);
    }

    public where(name: string, value: any): MeasurementTypeConfigurationsGet {
        this.filter().where(name, value);
        return this;
    }

    public whereEquals(name: string, value: any): MeasurementTypeConfigurationsGet {
        this.filter().whereEquals(name, value);
        return this;
    }

    public whereIn(name: string, value: any[]): MeasurementTypeConfigurationsGet {
        this.filter().whereIn(name, value);
        return this;
    }

    public whereInArray(name: string, value: any[]): MeasurementTypeConfigurationsGet {
        this.filter().whereInArray(name, value);
        return this;
    }

    public whereNot(name: string, value: any): MeasurementTypeConfigurationsGet {
        this.filter().whereNot(name, value);
        return this;
    }

    public whereNotIn(name: string, value: any[]): MeasurementTypeConfigurationsGet {
        this.filter().whereNotIn(name, value);
        return this;
    }

    public whereGreaterThan(name: string, value: any): MeasurementTypeConfigurationsGet {
        this.filter().whereGreaterThan(name, value);
        return this;
    }

    public whereGreaterThanOrEqual(name: string, value: any): MeasurementTypeConfigurationsGet {
        this.filter().whereGreaterThanOrEqual(name, value);
        return this;
    }

    public whereLessThan(name: string, value: any): MeasurementTypeConfigurationsGet {
        this.filter().whereLessThan(name, value);
        return this;
    }

    public whereLessThanOrEqual(name: string, value: any): MeasurementTypeConfigurationsGet {
        this.filter().whereLessThanOrEqual(name, value);
        return this;
    }

    public search(name: string, value: any): MeasurementTypeConfigurationsGet {
        this.filter().search(name, value);
        return this;
    }

    public include(name: string): MeasurementTypeConfigurationsGet {
        this.getInclude().include(name);
        return this;
    }

    public orderBy(name: string, direction: string): MeasurementTypeConfigurationsGet {
        this.ordering().orderBy(name, direction);
        return this;
    }

    public orderAsc(name: string): MeasurementTypeConfigurationsGet {
        this.ordering().orderAsc(name);
        return this;
    }

    public orderDesc(name: string): MeasurementTypeConfigurationsGet {
        this.ordering().orderDesc(name);
        return this;
    }

    public limit(value: number): MeasurementTypeConfigurationsGet {
        this.limitValue = value;
        return this;
    }

    public offset(value: number): MeasurementTypeConfigurationsGet {
        this.offsetValue = value;
        return this;
    }

    public count(next?: (value: number) => void) {
        return this.executeCount(next);
    }

    public find(next?: (value: MeasurementTypeConfiguration[]) => void) {
        return super.executeFind(next);
    }
}

export class MeasurementTypeConfigurationsGetById extends BaseApi<MeasurementTypeConfiguration> {

    public topic = 'Resources.MeasurementTypeConfigurations';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/measurement_type_configurations/${id}`;
    }

    protected convertToResource(data: any): MeasurementTypeConfiguration {
        return new MeasurementTypeConfiguration(data);
    }

    public include(name: string): MeasurementTypeConfigurationsGetById {
        this.getInclude().include(name);
        return this;
    }

    public find(next?: (value: MeasurementTypeConfiguration[]) => void) {
        return super.executeFind(next);
    }
}

export class MeasurementTypeConfigurationsPost extends BaseApi<MeasurementTypeConfiguration> {

    public topic = 'Resources.MeasurementTypeConfigurations';
    protected method = 'post';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/measurement_type_configurations`;
    }

    protected convertToResource(data: any): MeasurementTypeConfiguration {
        return new MeasurementTypeConfiguration(data);
    }

    public save(data: MeasurementTypeConfiguration, next?: (value: MeasurementTypeConfiguration) => void) {
        return super.executeSave(data, next);
    }
}

export class MeasurementTypeConfigurationsPutById extends BaseApi<MeasurementTypeConfiguration> {

    public topic = 'Resources.MeasurementTypeConfigurations';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/measurement_type_configurations/${id}`;
    }

    protected convertToResource(data: any): MeasurementTypeConfiguration {
        return new MeasurementTypeConfiguration(data);
    }

    public save(data: MeasurementTypeConfiguration, next?: (value: MeasurementTypeConfiguration) => void) {
        return super.executeSave(data, next);
    }
}

export class MeasurementTypeConfigurationsPut extends BaseApi<MeasurementTypeConfiguration> {

    public topic = 'Resources.MeasurementTypeConfigurations';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/measurement_type_configurations`;
    }

    protected convertToResource(data: any): MeasurementTypeConfiguration {
        return new MeasurementTypeConfiguration(data);
    }

    public save(data: MeasurementTypeConfiguration, next?: (value: MeasurementTypeConfiguration) => void) {
        return super.executeSave(data, next);
    }
}

export class MeasurementTypeConfigurationsPatchById extends BaseApi<MeasurementTypeConfiguration> {

    public topic = 'Resources.MeasurementTypeConfigurations';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/measurement_type_configurations/${id}`;
    }

    protected convertToResource(data: any): MeasurementTypeConfiguration {
        return new MeasurementTypeConfiguration(data);
    }

    public save(data: MeasurementTypeConfiguration, next?: (value: MeasurementTypeConfiguration) => void) {
        return super.executeSave(data, next);
    }
}

export class MeasurementTypeConfigurationsPatch extends BaseApi<MeasurementTypeConfiguration> {

    public topic = 'Resources.MeasurementTypeConfigurations';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/measurement_type_configurations`;
    }

    protected convertToResource(data: any): MeasurementTypeConfiguration {
        return new MeasurementTypeConfiguration(data);
    }

    public save(data: MeasurementTypeConfiguration, next?: (value: MeasurementTypeConfiguration) => void) {
        return super.executeSave(data, next);
    }
}

export class MeasurementTypeConfigurationsDeleteById extends BaseApi<MeasurementTypeConfiguration> {

    public topic = 'Resources.MeasurementTypeConfigurations';
    protected method = 'delete';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/measurement_type_configurations/${id}`;
    }

    protected convertToResource(data: any): MeasurementTypeConfiguration {
        return new MeasurementTypeConfiguration(data);
    }

    public delete(next?: (value: MeasurementTypeConfiguration) => void) {
        return super.executeDelete(next);
    }
}

class MeasurementTypeConfigurations {

    public get(): MeasurementTypeConfigurationsGet {
        return new MeasurementTypeConfigurationsGet();
    }

    public getById(id: number): MeasurementTypeConfigurationsGetById {
        return new MeasurementTypeConfigurationsGetById(id);
    }

    public post(): MeasurementTypeConfigurationsPost {
        return new MeasurementTypeConfigurationsPost();
    }

    public putById(id: number): MeasurementTypeConfigurationsPutById {
        return new MeasurementTypeConfigurationsPutById(id);
    }

    public put(): MeasurementTypeConfigurationsPut {
        return new MeasurementTypeConfigurationsPut();
    }

    public patchById(id: number): MeasurementTypeConfigurationsPatchById {
        return new MeasurementTypeConfigurationsPatchById(id);
    }

    public patch(): MeasurementTypeConfigurationsPatch {
        return new MeasurementTypeConfigurationsPatch();
    }

    public deleteById(id: number): MeasurementTypeConfigurationsDeleteById {
        return new MeasurementTypeConfigurationsDeleteById(id);
    }

}


export class MeasurementTypesIdentifiersGetGet extends BaseApi<any> {

    public topic = 'UnknownResource';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/measurement_types/identifiers`;
    }

    protected convertToResource(data: any): any {
        return data;
    }

    public category(value: string): MeasurementTypesIdentifiersGetGet {
        this.addQueryParameter('category', value);
        return this;
    }

    public find(next?: (value: any[]) => void) {
        return super.executeFind(next);
    }
}

class MeasurementTypes {

    public identifiersGetGet(): MeasurementTypesIdentifiersGetGet {
        return new MeasurementTypesIdentifiersGetGet();
    }

}


export class MeasurementsGet extends BaseApi<Measurement> {

    public topic = 'Resources.Measurements';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/measurements`;
    }

    protected convertToResource(data: any): Measurement {
        return new Measurement(data);
    }

    public where(name: string, value: any): MeasurementsGet {
        this.filter().where(name, value);
        return this;
    }

    public whereEquals(name: string, value: any): MeasurementsGet {
        this.filter().whereEquals(name, value);
        return this;
    }

    public whereIn(name: string, value: any[]): MeasurementsGet {
        this.filter().whereIn(name, value);
        return this;
    }

    public whereInArray(name: string, value: any[]): MeasurementsGet {
        this.filter().whereInArray(name, value);
        return this;
    }

    public whereNot(name: string, value: any): MeasurementsGet {
        this.filter().whereNot(name, value);
        return this;
    }

    public whereNotIn(name: string, value: any[]): MeasurementsGet {
        this.filter().whereNotIn(name, value);
        return this;
    }

    public whereGreaterThan(name: string, value: any): MeasurementsGet {
        this.filter().whereGreaterThan(name, value);
        return this;
    }

    public whereGreaterThanOrEqual(name: string, value: any): MeasurementsGet {
        this.filter().whereGreaterThanOrEqual(name, value);
        return this;
    }

    public whereLessThan(name: string, value: any): MeasurementsGet {
        this.filter().whereLessThan(name, value);
        return this;
    }

    public whereLessThanOrEqual(name: string, value: any): MeasurementsGet {
        this.filter().whereLessThanOrEqual(name, value);
        return this;
    }

    public search(name: string, value: any): MeasurementsGet {
        this.filter().search(name, value);
        return this;
    }

    public include(name: string): MeasurementsGet {
        this.getInclude().include(name);
        return this;
    }

    public orderBy(name: string, direction: string): MeasurementsGet {
        this.ordering().orderBy(name, direction);
        return this;
    }

    public orderAsc(name: string): MeasurementsGet {
        this.ordering().orderAsc(name);
        return this;
    }

    public orderDesc(name: string): MeasurementsGet {
        this.ordering().orderDesc(name);
        return this;
    }

    public limit(value: number): MeasurementsGet {
        this.limitValue = value;
        return this;
    }

    public offset(value: number): MeasurementsGet {
        this.offsetValue = value;
        return this;
    }

    public count(next?: (value: number) => void) {
        return this.executeCount(next);
    }

    public find(next?: (value: Measurement[]) => void) {
        return super.executeFind(next);
    }
}

export class MeasurementsGetById extends BaseApi<Measurement> {

    public topic = 'Resources.Measurements';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/measurements/${id}`;
    }

    protected convertToResource(data: any): Measurement {
        return new Measurement(data);
    }

    public include(name: string): MeasurementsGetById {
        this.getInclude().include(name);
        return this;
    }

    public find(next?: (value: Measurement[]) => void) {
        return super.executeFind(next);
    }
}

export class MeasurementsPost extends BaseApi<Measurement> {

    public topic = 'Resources.Measurements';
    protected method = 'post';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/measurements`;
    }

    protected convertToResource(data: any): Measurement {
        return new Measurement(data);
    }

    public save(data: Measurement, next?: (value: Measurement) => void) {
        return super.executeSave(data, next);
    }
}

export class MeasurementsPutById extends BaseApi<Measurement> {

    public topic = 'Resources.Measurements';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/measurements/${id}`;
    }

    protected convertToResource(data: any): Measurement {
        return new Measurement(data);
    }

    public save(data: Measurement, next?: (value: Measurement) => void) {
        return super.executeSave(data, next);
    }
}

export class MeasurementsPut extends BaseApi<Measurement> {

    public topic = 'Resources.Measurements';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/measurements`;
    }

    protected convertToResource(data: any): Measurement {
        return new Measurement(data);
    }

    public save(data: Measurement, next?: (value: Measurement) => void) {
        return super.executeSave(data, next);
    }
}

export class MeasurementsPatchById extends BaseApi<Measurement> {

    public topic = 'Resources.Measurements';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/measurements/${id}`;
    }

    protected convertToResource(data: any): Measurement {
        return new Measurement(data);
    }

    public save(data: Measurement, next?: (value: Measurement) => void) {
        return super.executeSave(data, next);
    }
}

export class MeasurementsPatch extends BaseApi<Measurement> {

    public topic = 'Resources.Measurements';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/measurements`;
    }

    protected convertToResource(data: any): Measurement {
        return new Measurement(data);
    }

    public save(data: Measurement, next?: (value: Measurement) => void) {
        return super.executeSave(data, next);
    }
}

export class MeasurementsDeleteById extends BaseApi<Measurement> {

    public topic = 'Resources.Measurements';
    protected method = 'delete';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/measurements/${id}`;
    }

    protected convertToResource(data: any): Measurement {
        return new Measurement(data);
    }

    public delete(next?: (value: Measurement) => void) {
        return super.executeDelete(next);
    }
}

class Measurements {

    public get(): MeasurementsGet {
        return new MeasurementsGet();
    }

    public getById(id: number): MeasurementsGetById {
        return new MeasurementsGetById(id);
    }

    public post(): MeasurementsPost {
        return new MeasurementsPost();
    }

    public putById(id: number): MeasurementsPutById {
        return new MeasurementsPutById(id);
    }

    public put(): MeasurementsPut {
        return new MeasurementsPut();
    }

    public patchById(id: number): MeasurementsPatchById {
        return new MeasurementsPatchById(id);
    }

    public patch(): MeasurementsPatch {
        return new MeasurementsPatch();
    }

    public deleteById(id: number): MeasurementsDeleteById {
        return new MeasurementsDeleteById(id);
    }

}


export class MedicinesGet extends BaseApi<Medicine> {

    public topic = 'Resources.Medicines';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/medicines`;
    }

    protected convertToResource(data: any): Medicine {
        return new Medicine(data);
    }

    public where(name: string, value: any): MedicinesGet {
        this.filter().where(name, value);
        return this;
    }

    public whereEquals(name: string, value: any): MedicinesGet {
        this.filter().whereEquals(name, value);
        return this;
    }

    public whereIn(name: string, value: any[]): MedicinesGet {
        this.filter().whereIn(name, value);
        return this;
    }

    public whereInArray(name: string, value: any[]): MedicinesGet {
        this.filter().whereInArray(name, value);
        return this;
    }

    public whereNot(name: string, value: any): MedicinesGet {
        this.filter().whereNot(name, value);
        return this;
    }

    public whereNotIn(name: string, value: any[]): MedicinesGet {
        this.filter().whereNotIn(name, value);
        return this;
    }

    public whereGreaterThan(name: string, value: any): MedicinesGet {
        this.filter().whereGreaterThan(name, value);
        return this;
    }

    public whereGreaterThanOrEqual(name: string, value: any): MedicinesGet {
        this.filter().whereGreaterThanOrEqual(name, value);
        return this;
    }

    public whereLessThan(name: string, value: any): MedicinesGet {
        this.filter().whereLessThan(name, value);
        return this;
    }

    public whereLessThanOrEqual(name: string, value: any): MedicinesGet {
        this.filter().whereLessThanOrEqual(name, value);
        return this;
    }

    public search(name: string, value: any): MedicinesGet {
        this.filter().search(name, value);
        return this;
    }

    public include(name: string): MedicinesGet {
        this.getInclude().include(name);
        return this;
    }

    public orderBy(name: string, direction: string): MedicinesGet {
        this.ordering().orderBy(name, direction);
        return this;
    }

    public orderAsc(name: string): MedicinesGet {
        this.ordering().orderAsc(name);
        return this;
    }

    public orderDesc(name: string): MedicinesGet {
        this.ordering().orderDesc(name);
        return this;
    }

    public limit(value: number): MedicinesGet {
        this.limitValue = value;
        return this;
    }

    public offset(value: number): MedicinesGet {
        this.offsetValue = value;
        return this;
    }

    public count(next?: (value: number) => void) {
        return this.executeCount(next);
    }

    public find(next?: (value: Medicine[]) => void) {
        return super.executeFind(next);
    }
}

export class MedicinesGetById extends BaseApi<Medicine> {

    public topic = 'Resources.Medicines';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/medicines/${id}`;
    }

    protected convertToResource(data: any): Medicine {
        return new Medicine(data);
    }

    public include(name: string): MedicinesGetById {
        this.getInclude().include(name);
        return this;
    }

    public find(next?: (value: Medicine[]) => void) {
        return super.executeFind(next);
    }
}

export class MedicinesPost extends BaseApi<Medicine> {

    public topic = 'Resources.Medicines';
    protected method = 'post';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/medicines`;
    }

    protected convertToResource(data: any): Medicine {
        return new Medicine(data);
    }

    public save(data: Medicine, next?: (value: Medicine) => void) {
        return super.executeSave(data, next);
    }
}

export class MedicinesPutById extends BaseApi<Medicine> {

    public topic = 'Resources.Medicines';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/medicines/${id}`;
    }

    protected convertToResource(data: any): Medicine {
        return new Medicine(data);
    }

    public save(data: Medicine, next?: (value: Medicine) => void) {
        return super.executeSave(data, next);
    }
}

export class MedicinesPut extends BaseApi<Medicine> {

    public topic = 'Resources.Medicines';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/medicines`;
    }

    protected convertToResource(data: any): Medicine {
        return new Medicine(data);
    }

    public save(data: Medicine, next?: (value: Medicine) => void) {
        return super.executeSave(data, next);
    }
}

export class MedicinesPatchById extends BaseApi<Medicine> {

    public topic = 'Resources.Medicines';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/medicines/${id}`;
    }

    protected convertToResource(data: any): Medicine {
        return new Medicine(data);
    }

    public save(data: Medicine, next?: (value: Medicine) => void) {
        return super.executeSave(data, next);
    }
}

export class MedicinesPatch extends BaseApi<Medicine> {

    public topic = 'Resources.Medicines';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/medicines`;
    }

    protected convertToResource(data: any): Medicine {
        return new Medicine(data);
    }

    public save(data: Medicine, next?: (value: Medicine) => void) {
        return super.executeSave(data, next);
    }
}

export class MedicinesDeleteById extends BaseApi<Medicine> {

    public topic = 'Resources.Medicines';
    protected method = 'delete';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/medicines/${id}`;
    }

    protected convertToResource(data: any): Medicine {
        return new Medicine(data);
    }

    public delete(next?: (value: Medicine) => void) {
        return super.executeDelete(next);
    }
}

class Medicines {

    public get(): MedicinesGet {
        return new MedicinesGet();
    }

    public getById(id: number): MedicinesGetById {
        return new MedicinesGetById(id);
    }

    public post(): MedicinesPost {
        return new MedicinesPost();
    }

    public putById(id: number): MedicinesPutById {
        return new MedicinesPutById(id);
    }

    public put(): MedicinesPut {
        return new MedicinesPut();
    }

    public patchById(id: number): MedicinesPatchById {
        return new MedicinesPatchById(id);
    }

    public patch(): MedicinesPatch {
        return new MedicinesPatch();
    }

    public deleteById(id: number): MedicinesDeleteById {
        return new MedicinesDeleteById(id);
    }

}


export class PrescriptionsGet extends BaseApi<Prescription> {

    public topic = 'Resources.Prescriptions';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/prescriptions`;
    }

    protected convertToResource(data: any): Prescription {
        return new Prescription(data);
    }

    public where(name: string, value: any): PrescriptionsGet {
        this.filter().where(name, value);
        return this;
    }

    public whereEquals(name: string, value: any): PrescriptionsGet {
        this.filter().whereEquals(name, value);
        return this;
    }

    public whereIn(name: string, value: any[]): PrescriptionsGet {
        this.filter().whereIn(name, value);
        return this;
    }

    public whereInArray(name: string, value: any[]): PrescriptionsGet {
        this.filter().whereInArray(name, value);
        return this;
    }

    public whereNot(name: string, value: any): PrescriptionsGet {
        this.filter().whereNot(name, value);
        return this;
    }

    public whereNotIn(name: string, value: any[]): PrescriptionsGet {
        this.filter().whereNotIn(name, value);
        return this;
    }

    public whereGreaterThan(name: string, value: any): PrescriptionsGet {
        this.filter().whereGreaterThan(name, value);
        return this;
    }

    public whereGreaterThanOrEqual(name: string, value: any): PrescriptionsGet {
        this.filter().whereGreaterThanOrEqual(name, value);
        return this;
    }

    public whereLessThan(name: string, value: any): PrescriptionsGet {
        this.filter().whereLessThan(name, value);
        return this;
    }

    public whereLessThanOrEqual(name: string, value: any): PrescriptionsGet {
        this.filter().whereLessThanOrEqual(name, value);
        return this;
    }

    public search(name: string, value: any): PrescriptionsGet {
        this.filter().search(name, value);
        return this;
    }

    public include(name: string): PrescriptionsGet {
        this.getInclude().include(name);
        return this;
    }

    public orderBy(name: string, direction: string): PrescriptionsGet {
        this.ordering().orderBy(name, direction);
        return this;
    }

    public orderAsc(name: string): PrescriptionsGet {
        this.ordering().orderAsc(name);
        return this;
    }

    public orderDesc(name: string): PrescriptionsGet {
        this.ordering().orderDesc(name);
        return this;
    }

    public limit(value: number): PrescriptionsGet {
        this.limitValue = value;
        return this;
    }

    public offset(value: number): PrescriptionsGet {
        this.offsetValue = value;
        return this;
    }

    public count(next?: (value: number) => void) {
        return this.executeCount(next);
    }

    public find(next?: (value: Prescription[]) => void) {
        return super.executeFind(next);
    }
}

export class PrescriptionsGetById extends BaseApi<Prescription> {

    public topic = 'Resources.Prescriptions';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/prescriptions/${id}`;
    }

    protected convertToResource(data: any): Prescription {
        return new Prescription(data);
    }

    public include(name: string): PrescriptionsGetById {
        this.getInclude().include(name);
        return this;
    }

    public find(next?: (value: Prescription[]) => void) {
        return super.executeFind(next);
    }
}

export class PrescriptionsPost extends BaseApi<Prescription> {

    public topic = 'Resources.Prescriptions';
    protected method = 'post';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/prescriptions`;
    }

    protected convertToResource(data: any): Prescription {
        return new Prescription(data);
    }

    public save(data: Prescription, next?: (value: Prescription) => void) {
        return super.executeSave(data, next);
    }
}

export class PrescriptionsPutById extends BaseApi<Prescription> {

    public topic = 'Resources.Prescriptions';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/prescriptions/${id}`;
    }

    protected convertToResource(data: any): Prescription {
        return new Prescription(data);
    }

    public save(data: Prescription, next?: (value: Prescription) => void) {
        return super.executeSave(data, next);
    }
}

export class PrescriptionsPut extends BaseApi<Prescription> {

    public topic = 'Resources.Prescriptions';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/prescriptions`;
    }

    protected convertToResource(data: any): Prescription {
        return new Prescription(data);
    }

    public save(data: Prescription, next?: (value: Prescription) => void) {
        return super.executeSave(data, next);
    }
}

export class PrescriptionsPatchById extends BaseApi<Prescription> {

    public topic = 'Resources.Prescriptions';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/prescriptions/${id}`;
    }

    protected convertToResource(data: any): Prescription {
        return new Prescription(data);
    }

    public save(data: Prescription, next?: (value: Prescription) => void) {
        return super.executeSave(data, next);
    }
}

export class PrescriptionsPatch extends BaseApi<Prescription> {

    public topic = 'Resources.Prescriptions';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/prescriptions`;
    }

    protected convertToResource(data: any): Prescription {
        return new Prescription(data);
    }

    public save(data: Prescription, next?: (value: Prescription) => void) {
        return super.executeSave(data, next);
    }
}

export class PrescriptionsDeleteById extends BaseApi<Prescription> {

    public topic = 'Resources.Prescriptions';
    protected method = 'delete';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/prescriptions/${id}`;
    }

    protected convertToResource(data: any): Prescription {
        return new Prescription(data);
    }

    public delete(next?: (value: Prescription) => void) {
        return super.executeDelete(next);
    }
}

class Prescriptions {

    public get(): PrescriptionsGet {
        return new PrescriptionsGet();
    }

    public getById(id: number): PrescriptionsGetById {
        return new PrescriptionsGetById(id);
    }

    public post(): PrescriptionsPost {
        return new PrescriptionsPost();
    }

    public putById(id: number): PrescriptionsPutById {
        return new PrescriptionsPutById(id);
    }

    public put(): PrescriptionsPut {
        return new PrescriptionsPut();
    }

    public patchById(id: number): PrescriptionsPatchById {
        return new PrescriptionsPatchById(id);
    }

    public patch(): PrescriptionsPatch {
        return new PrescriptionsPatch();
    }

    public deleteById(id: number): PrescriptionsDeleteById {
        return new PrescriptionsDeleteById(id);
    }

}


export class TherapistsGet extends BaseApi<Therapist> {

    public topic = 'Resources.Therapists';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/therapists`;
    }

    protected convertToResource(data: any): Therapist {
        return new Therapist(data);
    }

    public where(name: string, value: any): TherapistsGet {
        this.filter().where(name, value);
        return this;
    }

    public whereEquals(name: string, value: any): TherapistsGet {
        this.filter().whereEquals(name, value);
        return this;
    }

    public whereIn(name: string, value: any[]): TherapistsGet {
        this.filter().whereIn(name, value);
        return this;
    }

    public whereInArray(name: string, value: any[]): TherapistsGet {
        this.filter().whereInArray(name, value);
        return this;
    }

    public whereNot(name: string, value: any): TherapistsGet {
        this.filter().whereNot(name, value);
        return this;
    }

    public whereNotIn(name: string, value: any[]): TherapistsGet {
        this.filter().whereNotIn(name, value);
        return this;
    }

    public whereGreaterThan(name: string, value: any): TherapistsGet {
        this.filter().whereGreaterThan(name, value);
        return this;
    }

    public whereGreaterThanOrEqual(name: string, value: any): TherapistsGet {
        this.filter().whereGreaterThanOrEqual(name, value);
        return this;
    }

    public whereLessThan(name: string, value: any): TherapistsGet {
        this.filter().whereLessThan(name, value);
        return this;
    }

    public whereLessThanOrEqual(name: string, value: any): TherapistsGet {
        this.filter().whereLessThanOrEqual(name, value);
        return this;
    }

    public search(name: string, value: any): TherapistsGet {
        this.filter().search(name, value);
        return this;
    }

    public include(name: string): TherapistsGet {
        this.getInclude().include(name);
        return this;
    }

    public orderBy(name: string, direction: string): TherapistsGet {
        this.ordering().orderBy(name, direction);
        return this;
    }

    public orderAsc(name: string): TherapistsGet {
        this.ordering().orderAsc(name);
        return this;
    }

    public orderDesc(name: string): TherapistsGet {
        this.ordering().orderDesc(name);
        return this;
    }

    public limit(value: number): TherapistsGet {
        this.limitValue = value;
        return this;
    }

    public offset(value: number): TherapistsGet {
        this.offsetValue = value;
        return this;
    }

    public count(next?: (value: number) => void) {
        return this.executeCount(next);
    }

    public find(next?: (value: Therapist[]) => void) {
        return super.executeFind(next);
    }
}

export class TherapistsGetById extends BaseApi<Therapist> {

    public topic = 'Resources.Therapists';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/therapists/${id}`;
    }

    protected convertToResource(data: any): Therapist {
        return new Therapist(data);
    }

    public include(name: string): TherapistsGetById {
        this.getInclude().include(name);
        return this;
    }

    public find(next?: (value: Therapist[]) => void) {
        return super.executeFind(next);
    }
}

export class TherapistsPost extends BaseApi<Therapist> {

    public topic = 'Resources.Therapists';
    protected method = 'post';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/therapists`;
    }

    protected convertToResource(data: any): Therapist {
        return new Therapist(data);
    }

    public save(data: Therapist, next?: (value: Therapist) => void) {
        return super.executeSave(data, next);
    }
}

export class TherapistsPutById extends BaseApi<Therapist> {

    public topic = 'Resources.Therapists';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/therapists/${id}`;
    }

    protected convertToResource(data: any): Therapist {
        return new Therapist(data);
    }

    public save(data: Therapist, next?: (value: Therapist) => void) {
        return super.executeSave(data, next);
    }
}

export class TherapistsPut extends BaseApi<Therapist> {

    public topic = 'Resources.Therapists';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/therapists`;
    }

    protected convertToResource(data: any): Therapist {
        return new Therapist(data);
    }

    public save(data: Therapist, next?: (value: Therapist) => void) {
        return super.executeSave(data, next);
    }
}

export class TherapistsPatchById extends BaseApi<Therapist> {

    public topic = 'Resources.Therapists';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/therapists/${id}`;
    }

    protected convertToResource(data: any): Therapist {
        return new Therapist(data);
    }

    public save(data: Therapist, next?: (value: Therapist) => void) {
        return super.executeSave(data, next);
    }
}

export class TherapistsPatch extends BaseApi<Therapist> {

    public topic = 'Resources.Therapists';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/therapists`;
    }

    protected convertToResource(data: any): Therapist {
        return new Therapist(data);
    }

    public save(data: Therapist, next?: (value: Therapist) => void) {
        return super.executeSave(data, next);
    }
}

export class TherapistsDeleteById extends BaseApi<Therapist> {

    public topic = 'Resources.Therapists';
    protected method = 'delete';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/therapists/${id}`;
    }

    protected convertToResource(data: any): Therapist {
        return new Therapist(data);
    }

    public delete(next?: (value: Therapist) => void) {
        return super.executeDelete(next);
    }
}

class Therapists {

    public get(): TherapistsGet {
        return new TherapistsGet();
    }

    public getById(id: number): TherapistsGetById {
        return new TherapistsGetById(id);
    }

    public post(): TherapistsPost {
        return new TherapistsPost();
    }

    public putById(id: number): TherapistsPutById {
        return new TherapistsPutById(id);
    }

    public put(): TherapistsPut {
        return new TherapistsPut();
    }

    public patchById(id: number): TherapistsPatchById {
        return new TherapistsPatchById(id);
    }

    public patch(): TherapistsPatch {
        return new TherapistsPatch();
    }

    public deleteById(id: number): TherapistsDeleteById {
        return new TherapistsDeleteById(id);
    }

}


export class UsersGet extends BaseApi<User> {

    public topic = 'Resources.Users';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/users`;
    }

    protected convertToResource(data: any): User {
        return new User(data);
    }

    public where(name: string, value: any): UsersGet {
        this.filter().where(name, value);
        return this;
    }

    public whereEquals(name: string, value: any): UsersGet {
        this.filter().whereEquals(name, value);
        return this;
    }

    public whereIn(name: string, value: any[]): UsersGet {
        this.filter().whereIn(name, value);
        return this;
    }

    public whereInArray(name: string, value: any[]): UsersGet {
        this.filter().whereInArray(name, value);
        return this;
    }

    public whereNot(name: string, value: any): UsersGet {
        this.filter().whereNot(name, value);
        return this;
    }

    public whereNotIn(name: string, value: any[]): UsersGet {
        this.filter().whereNotIn(name, value);
        return this;
    }

    public whereGreaterThan(name: string, value: any): UsersGet {
        this.filter().whereGreaterThan(name, value);
        return this;
    }

    public whereGreaterThanOrEqual(name: string, value: any): UsersGet {
        this.filter().whereGreaterThanOrEqual(name, value);
        return this;
    }

    public whereLessThan(name: string, value: any): UsersGet {
        this.filter().whereLessThan(name, value);
        return this;
    }

    public whereLessThanOrEqual(name: string, value: any): UsersGet {
        this.filter().whereLessThanOrEqual(name, value);
        return this;
    }

    public search(name: string, value: any): UsersGet {
        this.filter().search(name, value);
        return this;
    }

    public include(name: string): UsersGet {
        this.getInclude().include(name);
        return this;
    }

    public orderBy(name: string, direction: string): UsersGet {
        this.ordering().orderBy(name, direction);
        return this;
    }

    public orderAsc(name: string): UsersGet {
        this.ordering().orderAsc(name);
        return this;
    }

    public orderDesc(name: string): UsersGet {
        this.ordering().orderDesc(name);
        return this;
    }

    public limit(value: number): UsersGet {
        this.limitValue = value;
        return this;
    }

    public offset(value: number): UsersGet {
        this.offsetValue = value;
        return this;
    }

    public count(next?: (value: number) => void) {
        return this.executeCount(next);
    }

    public find(next?: (value: User[]) => void) {
        return super.executeFind(next);
    }
}

export class UsersGetById extends BaseApi<User> {

    public topic = 'Resources.Users';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/users/${id}`;
    }

    protected convertToResource(data: any): User {
        return new User(data);
    }

    public include(name: string): UsersGetById {
        this.getInclude().include(name);
        return this;
    }

    public find(next?: (value: User[]) => void) {
        return super.executeFind(next);
    }
}

export class UsersPost extends BaseApi<User> {

    public topic = 'Resources.Users';
    protected method = 'post';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/users`;
    }

    protected convertToResource(data: any): User {
        return new User(data);
    }

    public save(data: User, next?: (value: User) => void) {
        return super.executeSave(data, next);
    }
}

export class UsersPutById extends BaseApi<User> {

    public topic = 'Resources.Users';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/users/${id}`;
    }

    protected convertToResource(data: any): User {
        return new User(data);
    }

    public save(data: User, next?: (value: User) => void) {
        return super.executeSave(data, next);
    }
}

export class UsersPut extends BaseApi<User> {

    public topic = 'Resources.Users';
    protected method = 'put';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/users`;
    }

    protected convertToResource(data: any): User {
        return new User(data);
    }

    public save(data: User, next?: (value: User) => void) {
        return super.executeSave(data, next);
    }
}

export class UsersPatchById extends BaseApi<User> {

    public topic = 'Resources.Users';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/users/${id}`;
    }

    protected convertToResource(data: any): User {
        return new User(data);
    }

    public save(data: User, next?: (value: User) => void) {
        return super.executeSave(data, next);
    }
}

export class UsersPatch extends BaseApi<User> {

    public topic = 'Resources.Users';
    protected method = 'patch';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/users`;
    }

    protected convertToResource(data: any): User {
        return new User(data);
    }

    public save(data: User, next?: (value: User) => void) {
        return super.executeSave(data, next);
    }
}

export class UsersDeleteById extends BaseApi<User> {

    public topic = 'Resources.Users';
    protected method = 'delete';
    protected scope = '';
    protected summary = '';

    public constructor(id: number) {
        super();
        this.uri = `/users/${id}`;
    }

    protected convertToResource(data: any): User {
        return new User(data);
    }

    public delete(next?: (value: User) => void) {
        return super.executeDelete(next);
    }
}

export class UsersMeGet extends BaseApi<User> {

    public topic = 'Resources.Users';
    protected method = 'get';
    protected scope = '';
    protected summary = '';

    public constructor() {
        super();
        this.uri = `/users/me`;
    }

    protected convertToResource(data: any): User {
        return new User(data);
    }

    public find(next?: (value: User[]) => void) {
        return super.executeFind(next);
    }
}

class Users {

    public get(): UsersGet {
        return new UsersGet();
    }

    public getById(id: number): UsersGetById {
        return new UsersGetById(id);
    }

    public post(): UsersPost {
        return new UsersPost();
    }

    public putById(id: number): UsersPutById {
        return new UsersPutById(id);
    }

    public put(): UsersPut {
        return new UsersPut();
    }

    public patchById(id: number): UsersPatchById {
        return new UsersPatchById(id);
    }

    public patch(): UsersPatch {
        return new UsersPatch();
    }

    public deleteById(id: number): UsersDeleteById {
        return new UsersDeleteById(id);
    }

    public meGet(): UsersMeGet {
        return new UsersMeGet();
    }

}

export class Api {

    public static bloodPressures(): BloodPressures {
        return new BloodPressures();
    }

    public static clients(): Clients {
        return new Clients();
    }

    public static integrationsTypeform(): IntegrationsTypeform {
        return new IntegrationsTypeform();
    }

    public static measurementTypeConfigurations(): MeasurementTypeConfigurations {
        return new MeasurementTypeConfigurations();
    }

    public static measurementTypes(): MeasurementTypes {
        return new MeasurementTypes();
    }

    public static measurements(): Measurements {
        return new Measurements();
    }

    public static medicines(): Medicines {
        return new Medicines();
    }

    public static prescriptions(): Prescriptions {
        return new Prescriptions();
    }

    public static therapists(): Therapists {
        return new Therapists();
    }

    public static users(): Users {
        return new Users();
    }

}
